<section class="e-tax-invoice-send-and-scan">
  <div class="box">
    <div class="box-content">
      <h3 class="box-content__heading">
        <span [innerHTML]="'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.HEADING' | translate"></span>
      </h3>
      <div class="box-content__menu">
        <ng-container *ngFor="let item of mockContent; let i = index">
          <div class="box-content__menu--nav">
            <div class="nav-bar" [ngClass]="{ active: currentSlide === i + 1 }" (click)="goToSlide(i + 1)">
              <span>{{
                'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.NAVBAR.' + (i + 1) | translate
              }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-container *ngFor="let item of mockContent; let i = index">
      <div class="box-wrapper" *ngIf="currentSlide === i + 1" [ngClass]="{ slide: currentSlide === i + 1 }">
        <div class="box-wrapper__left">
          <div class="box-wrapper__left--title">
            <span>{{
              'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.CONTENT.' + (i + 1) + '.HEADING'
                | translate
            }}</span>
          </div>
          <ng-container *ngFor="let itemContent of item.content; let index = index">
            <div class="box-wrapper__left--clearfix">
              <div class="clearfix-info--number">
                <span>{{ index + 1 }}</span>
              </div>
              <div class="clearfix-info--text">
                <div class="text-title">
                  <span>{{ itemContent.title | translate }}</span>
                </div>
                <div class="text-detail">
                  <span [innerHTML]="itemContent.detail | translate"></span>
                </div>
                <div *ngIf="itemContent.link && itemContent.connect" class="text-connect">
                  <a class="text-connect__link" [href]="itemContent.link" target="_blank" rel="noreferrer noopener"
                    ><span>{{ itemContent.connect | translate }}</span></a
                  >
                  <i class="fas fa-angle-right"></i>
                </div>
              </div>
            </div>
            <hr *ngIf="index < item.content.length - 1" />
          </ng-container>
        </div>
        <div class="box-wrapper__right">
          <div class="box-wrapper__right--img">
            <picture>
              <source [srcset]="item.imageWebp" type="image/webp" />
              <img
                [src]="item.image"
                [alt]="'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_SEND_AND_SCAN.NAVBAR.' + (i + 1) | translate"
                loading="lazy"
                class="img-layout"
              />
            </picture>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
